var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouCurious(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    transform: "translate(1.31 1.259)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M19.198 32.857H46.14v26.942H19.198z",
    "data-name": "Rectangle 14426"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m26.125 60.263-2.743 9.582.61 9.393",
    "data-name": "Path 40193"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m24.023 86.39-11.22-4.958 2.457-5.56 11.22 4.959z",
    "data-name": "Rectangle 14427"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m41.76 60.363-.624 9.482 2.188 9.495",
    "data-name": "Path 40194"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M46.25 85.817H33.984v-6.078H46.25z",
    "data-name": "Rectangle 14428"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.549,
    cy: 13.549,
    r: 13.549,
    strokeMiterlimit: 10,
    "data-name": "Ellipse 740",
    transform: "translate(18.71)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M45.808 13.549 4.12.001",
    "data-name": "Line 4346"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20.813 22.66-6.541 8.876 17.753 8.877",
    "data-name": "Path 40195"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m20.724 20.663 4.294 1.062",
    "data-name": "Line 4347"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.457,
    cy: 0.457,
    r: 0.457,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-name": "Ellipse 741",
    transform: "translate(23.532 12.269)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m5.73 66.945 4.833 6.74",
    "data-name": "Line 4348"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m0 78.03 7.639 3.228",
    "data-name": "Line 4349"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouCurious);
export default __webpack_public_path__ + "static/media/youCurious.94e881e5cbdbb2ec8bef22963493a098.svg";
export { ForwardRef as ReactComponent };